import React, {useCallback, useContext, useMemo, useState} from "react";
import {Button, Modal} from "react-bootstrap";
import DaumPostcode from "react-daum-postcode";
import {SET_DELIVERY_DATA} from "../../WizardConstants";
import {WizardContext} from "../Wizard";

export function PostCodeModal({ handleZipcode, handleAddress1 }) {
    const { dispatch } = useContext(WizardContext);

    const [postCodeShow, setPostCodeShow] = useState(false);

    const handleShow = useCallback((e) => {
            setPostCodeShow(true)
        }, []);

    const handleHide = useCallback((e) => {
            setPostCodeShow(false)
        }, []);

    const handleComplete = useCallback((data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if(data.addressType === 'R') {
            if(data.bname !== '') {
                extraAddress += data.bname;
            }
            if(data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }

            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }
        dispatch({ type: SET_DELIVERY_DATA, zipcode: data.zonecode, address1: fullAddress, isPostCode: true })
        handleZipcode(data.zonecode);
        handleAddress1(fullAddress);
        setPostCodeShow(false);
    },[dispatch, handleZipcode, handleAddress1])

    const daumPostCode = useMemo(() => {
        return <DaumPostcode onComplete={handleComplete} autoClose={true} />
    }, [handleComplete]);

    return (
        <>
            <Button variant="primary" onClick={handleShow}>
               주소검색
            </Button>

            <Modal
                show={postCodeShow}
                onHide={handleHide}
                dialogClassName="modal-90w"
                // aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Body className="p-0">
                    {daumPostCode}
                </Modal.Body>
            </Modal>
        </>
    );
}

